module.exports = __webpack_public_path__ + "static/baked_goods-383628faba4f8533bacb9e1660887045.jpg";